import React from 'react'
import { LinearProgress, linearProgressClasses, Box } from '@mui/material'
import { styled } from '@mui/material/styles'

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 30,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.mode === 'light' ? '#1a90ff' : '#308fe8',
  },
}))

export const LinearBarChart = ({values, colors1, colors2}) => {
  const [firstValue, secondValue] = values
  const total = firstValue + secondValue

  const firstWidth = (firstValue * 100) / total
  const secondWitdh = (secondValue * 100) / total

  return (
    <Box>
      <div style={{ width: `${firstWidth}%`, display: 'inline-block' }}>
        <BorderLinearProgress variant="determinate" value={100} sx={{ '& .MuiLinearProgress-bar': { backgroundColor: colors1 } }}/>
      </div>
      <div style={{ width: `${secondWitdh}%`, display: 'inline-block' }}>
        <BorderLinearProgress
          variant="determinate"
          value={100}
          sx={{ '& .MuiLinearProgress-bar': { backgroundColor: colors2 } }}
        />
      </div>
    </Box>
  )
}
